<div
  class="colored-badge"
  [style.maxWidth]="maxWidth"
  [style.color]="_color"
  [style.backgroundColor]="_backgroundColor"
  [class.colored-badge--fixed]="maxWidth"
  [class.colored-badge--kp]="variant === 'kp'"
  [class.empty]="!icon && !text"
>
  <i *ngIf="icon" class="colored-badge__icon" [ngClass]="icon" [style.color]="_iconColor"></i>
  {{ variant === "kp" ? text : (text | uppercase) }}
</div>
